import {Component, Inject} from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'feedback-dialog',
    templateUrl: 'feedback.dialog.html',
    styles: ['feedback.dialog.css']
})
export class FeedbackDialog {

    constructor(@Inject(MAT_DIALOG_DATA) public data: {
        correctness: boolean,
        responseTime: number,
        showTime: boolean
    },
    public translate: TranslateService){

    }
}
